$(document).ready(function() {
    
    getCompare();

    $('.export-pdf').on('click', function() {
        $('.buttons-pdf').trigger('click');
    });

    $('#table-pdf').DataTable({
        paging: false,
        ordering: false,
        searching: false,
        info: false,
        dom: 'Bfrtip',
        buttons: [
            {
                extend: 'pdfHtml5',
                text: 'Export to PDF',
                title: 'Beelink - Product Comparison',
                orientation: 'landscape',
                pageSize: 'Letter',
                exportOptions: {
                    modifier: {
                        page: 'all'
                    }
                },
                customize: function (doc) {
                    if (doc.content.length > 1 && doc.content[1].table && doc.content[1].table.body) {
                        doc.content[1].table.body.splice(0, 1);
                    }
    
                    doc.content[1].layout = {
                        hLineWidth: function (i) {
                            return 1; // Sets the width of horizontal lines
                        },
                        vLineWidth: function (i) {
                            return 1; // Sets the width of vertical lines
                        },
                        hLineColor: function (i) {
                            return '#000'; // Sets the color of horizontal lines
                        },
                        vLineColor: function (i) {
                            return '#000'; // Sets the color of vertical lines
                        },
                        paddingLeft: function(i, node) {
                            return 5; // Set left padding
                        },
                        paddingRight: function(i, node) {
                            return 5; // Set right padding
                        },
                        paddingTop: function(i, node) {
                            return 5; // Set top padding
                        },
                        paddingBottom: function(i, node) {
                            return 5; // Set bottom padding
                        }
                    };
    
                    doc.content[1].styles = {
                        tableCell: {
                            margin: [0, 5]
                        }
                    };
                    doc.content[1].table.body.forEach(function (row) {
                        row.forEach(function (cell) {
                            cell.style = 'tableCell';
                        });
                    });
                }
            }
        ]
    });
});

function getCompare() {

    $(`.compare .model .remove`).removeClass().addClass('remove')
    $(`.compare .model .product img`).attr('src', '');
    $(`.compare .model .title`).html('');
    $(`.compare .model .product .btn-beelink`).attr('href', '');

    $('.compare .model .product').hide();
    $('.compare .model .empty').show();
    $('.compare .data').html('');

    $('.table-data').html('');

    let idx = 0;
    compare.forEach(product => {

        $(`.compare .model .remove:eq(${idx})`).addClass(product.id)
        $(`.compare .model .product:eq(${idx}) img`).attr('src', product.featured_image);
        $(`.compare .model .title:eq(${idx})`).html(product.title);
        $(`.compare .model .product:eq(${idx}) .btn-beelink`).attr('href', product.url);

        $(`.compare .model .product:eq(${idx})`).css('display', 'flex');
        $(`.compare .model .empty:eq(${idx})`).hide();

        $(`.compare .data--price:eq(${idx})`).html(product.price);
        $(`.compare .data--processor:eq(${idx})`).html(product.processor);
        $(`.compare .data--graphics:eq(${idx})`).html(product.graphics);
        $(`.compare .data--memory:eq(${idx})`).html(product.memory);
        $(`.compare .data--storage:eq(${idx})`).html(product.storage);
        $(`.compare .data--display_support:eq(${idx})`).html(product.display_support);
        $(`.compare .data--wireless_network:eq(${idx})`).html(product.wireless_network);
        $(`.compare .data--lan:eq(${idx})`).html(product.lan);
        $(`.compare .data--audio:eq(${idx})`).html(product.audio);
        $(`.compare .data--front_io:eq(${idx})`).html(product.front_io);
        $(`.compare .data--back_io:eq(${idx})`).html(product.back_io);
        $(`.compare .data--color:eq(${idx})`).html(product.color);
        $(`.compare .data--size:eq(${idx})`).html(product.size);
        $(`.compare .data--weight:eq(${idx})`).html(product.weight);
        $(`.compare .data--adapter:eq(${idx})`).html(product.adapter);

        $(`.table--model:eq(${idx})`).html(product.title);
        $(`.table--price:eq(${idx})`).html(product.price);
        $(`.table--processor:eq(${idx})`).html(product.processor);
        $(`.table--graphics:eq(${idx})`).html(product.graphics);
        $(`.table--memory:eq(${idx})`).html(product.memory);
        $(`.table--storage:eq(${idx})`).html(product.storage);
        $(`.table--display_support:eq(${idx})`).html(product.display_support);
        $(`.table--wireless_network:eq(${idx})`).html(product.wireless_network);
        $(`.table--lan:eq(${idx})`).html(product.lan);
        $(`.table--audio:eq(${idx})`).html(product.audio);
        $(`.table--front_io:eq(${idx})`).html(product.front_io);
        $(`.table--back_io:eq(${idx})`).html(product.back_io);
        $(`.table--color:eq(${idx})`).html(product.color);
        $(`.table--size:eq(${idx})`).html(product.size);
        $(`.table--weight:eq(${idx})`).html(product.weight);
        $(`.table--adapter:eq(${idx})`).html(product.adapter);

        idx++;
    });
}

$('.compare .remove').on('click', function(e) {
    e.preventDefault();

    let storedCompareArrayString = sessionStorage.getItem('compare');
    let storedCompareArray = JSON.parse(storedCompareArrayString);

    let removeId = $(this).attr('class').replace('remove ', '');

    if (storedCompareArray.length == 1 && storedCompareArray[0].id == removeId) {
        storedCompareArray = [];
    } 
    else {
        storedCompareArray = storedCompareArray.filter(function(item) {
            return item.id != removeId;
        });
    }

    $(this).removeClass().addClass('remove');

    let updatedCompareArrayString = JSON.stringify(storedCompareArray);

    sessionStorage.setItem('compare', updatedCompareArrayString);

    filterCompare();
    getCompare();
});